<template>
  <div class="flex justify-start bottom-0 px-3 pb-5">
    <a
      :href="mailtoLink"
      target="_blank"
      aria-label="Écrivez-nous !"
      title="Écrivez-nous !"
      rel="noopener noreferrer"
      class="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-primaire rounded-lg hover:bg-navigation focus:ring-4 focus:outline-none focus:ring-primaire dark:primaire dark:hover:bg-navigation dark:focus:ring-primaire">
      Je l'ai trouvé ! 😹
    </a>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  email: {
    type: String,
    default: 'info@animauxdelasecondechance.com',
  },
  animal: {
    type: Object,
    required: true,
  }
});

const subject = computed(() => 
  `Chat perdu trouvé ${props.animal.title || ''} !`
);

const body = computed(() => {
  let details = props.animal.content?.join('\n') || '';
  return encodeURIComponent(
    `Bonjour,\n\nJ'ai trouvé un chat qui correspond à cette annonce :\n\nNom: ${props.animal.title}\n${details}\n\nMerci de me contacter pour plus d'informations.`
  );
});

const mailtoLink = computed(() => {
  return `mailto:${props.email}?subject=${encodeURIComponent(subject.value)}&body=${body.value}`;
}

);

</script>